import Divider from '../../components/Divider/Divider';
import { addressItems } from '../../data/data';
const Address = () => {
  return (
    <section className='address'>
      <Divider />
      <div className='address__container'>
        <h2 className='address__title title color'>
          Legal Address
          <span className='title'> and License</span>
        </h2>
        <div className='address__inner'>
          {addressItems.map((item) => (
            <p key={item.id} className='address__text text-large'>
              {item.texthref && item.href ? (
                <>
                  {item.text}
                  <a
                    href={item.href}
                    rel='noopener noreferrer'
                    target='_blank'
                    className='address__link'
                  >
                    &nbsp;{item.texthref}
                  </a>
                </>
              ) : (
                item.text
              )}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Address;
